import axios from "axios";
import { useAuth } from "@clerk/react";
import { createContext, useContext, useEffect, useMemo, useState } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const publicApi = axios.create({ baseURL: API });

export function useApi() {
  const { getToken } = useAuth();
  return useMemo(() => {
    const i = axios.create({ baseURL: API });
    i.interceptors.request.use(async (c) => {
      const t = await getToken();
      if (t) c.headers.Authorization = `Bearer ${t}`;
      return c;
    });
    return i;
  }, [getToken]);
}

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d?.message) return d.message;
  return "Something went wrong. Please try again.";
};

export const money = (v, sym = "", dec = 0, cur = "") =>
  v === null || v === undefined ? "—" : `${sym}${Number(v).toLocaleString(sym === "₹" || cur === "INR" ? "en-IN" : "en-US", { minimumFractionDigits: dec, maximumFractionDigits: dec })}`;

const MeCtx = createContext({ me: null, reload: () => {} });

export function MeProvider({ children }) {
  const { isSignedIn } = useAuth();
  const api = useApi();
  const [me, setMe] = useState(null);
  const reload = () => api.get("/me").then((r) => setMe(r.data)).catch(() => setMe(null));
  useEffect(() => {
    if (isSignedIn) { reload(); } else { setMe(null); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSignedIn]);
  return <MeCtx.Provider value={{ me, reload }}>{children}</MeCtx.Provider>;
}

export const useMe = () => useContext(MeCtx);

export const STATUS_LABELS = {
  not_required: ["Not required", "This isn't needed for your website."],
  not_started: ["Not started", "Nothing has been done yet."],
  in_progress: ["In progress", "Setup has begun."],
  awaiting_customer: ["Waiting for you", "We need something from you to continue."],
  awaiting_verification: ["Awaiting verification", "Altiora will test the connection."],
  connected_tested: ["Connected and tested", "Altiora tested this and it works."],
  failed: ["Needs attention", "Something went wrong — we'll help fix it."],
  to_be_purchased: ["To be purchased", "The domain still needs to be bought in your registrar account."],
  purchased_connection_pending: ["Purchased — connection pending", "You own it; it still needs to be pointed to the website."],
  connected: ["Connected", "Your domain points to the website."],
  issue_detected: ["Issue detected", "Something is wrong with the domain setup."],
  assessment_pending: ["Assessment pending", "We'll assess technical needs before recommending hosting."],
};
